import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const BUYERS = [{
  name: 'Marta R.',
  city: 'Buenos Aires'
}, {
  name: 'Jorge L.',
  city: 'Córdoba'
}, {
  name: 'Susana M.',
  city: 'Rosario'
}, {
  name: 'Héctor P.',
  city: 'Mar del Plata'
}, {
  name: 'Norma G.',
  city: 'La Plata'
}, {
  name: 'Carlos A.',
  city: 'Mendoza'
}, {
  name: 'Graciela T.',
  city: 'Tucumán'
}, {
  name: 'Roberto D.',
  city: 'Santa Fe'
}, {
  name: 'Elena V.',
  city: 'Salta'
}, {
  name: 'Alicia F.',
  city: 'Bahía Blanca'
}, {
  name: 'Oscar B.',
  city: 'Neuquén'
}, {
  name: 'María C.',
  city: 'Paraná'
}, {
  name: 'Ricardo S.',
  city: 'San Juan'
}, {
  name: 'Liliana H.',
  city: 'Corrientes'
}, {
  name: 'Eduardo N.',
  city: 'Resistencia'
}];
function getRandomBuyer() {
  return BUYERS[Math.floor(Math.random() * BUYERS.length)];
}
function getRandomMinutes() {
  return Math.floor(Math.random() * 12) + 2; // 2-13 minutes ago
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer());
  const [minutesAgo, setMinutesAgo] = useState(getRandomMinutes());
  useEffect(() => {
    const showPopup = () => {
      setBuyer(getRandomBuyer());
      setMinutesAgo(getRandomMinutes());
      setVisible(true);
      setTimeout(() => setVisible(false), 3500);
    };
    const initialTimeout = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 7000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-219">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-220">
          <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-4 flex items-start gap-3" data-id="element-221">
            <div className="bg-sage-100 p-2 rounded-full shrink-0" data-id="element-222">
              <ShoppingBag size={20} className="text-sage-700" data-id="element-223" />
            </div>
            <div className="min-w-0" data-id="element-224">
              <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-225">
                {buyer.name} de {buyer.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-226">
                compró el Kit Mente Clara & Activa
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-227">
                hace {minutesAgo} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-gray-400 hover:text-gray-600 shrink-0 text-lg leading-none ml-1" aria-label="Cerrar notificación" data-id="element-228">
              ×
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}